import { useMemo } from "react";

export const useReportRules = () => {
  return useMemo(
    () => [
      {
        required: true,
        message: "Please provide the details",
        validateTrigger: "onSubmit",
      },
      {
        max: 5000,
        message: "Details shouldn't contain more than 5000 characters",
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );
};
